<template>
    <div class="global_content_course" :class="{ dark: Boolean(dark) }">
        <div
            v-if="showSidebar && isMobileLayout"
            class="course-layout__overlay"
            aria-hidden="true"
            @click="closeSidebar"
        />
        <div class="course-layout">
            <aside
                id="course-lessons-drawer"
                class="course-layout__sidebar"
                :class="showSidebar ? 'is-visible' : 'is-hidden'"
                :aria-hidden="isMobileLayout && !showSidebar ? 'true' : 'false'"
            >
                <SideBar
                    :activeModule="activeModule"
                    :nameCourse="nameCourse"
                    :data="dataModulesxLesson"
                    :currentLesson="currentLesson"
                    @updateLessonName="updateCurrentLessonName"
                    @lessonChanged="updateCurrentLesson"
                    @typeChanged="updateCurrentTypeLesson"
                />
            </aside>
            <div class="course-layout__main course-layout__main--with-home-header">
                <Header
                    course-sidebar-menu
                    :course-modules="dataModulesxLesson"
                />
                <ViewCourse
                    :modules-data="dataModulesxLesson"
                    :course-name="courseDisplayName"
                    :modules-loading="modulesLoading"
                    @progress-updated="onProgressUpdated"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './sidebar.vue';
import ViewCourse from './viewContent.vue';
import Header from '@/components/Student/Dashboard_Unique/Header/Header.vue';

import api from '@/utils/portal/modulesLesson.js';
import apiCourse from '@/utils/portal/course.js';
import { resolvePortalModuleToken } from '@/utils/portal/courseToken';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    data() {
        return {
            dataModulesxLesson: null,
            currentLessonLocal: null,
            currentLessonName: null,
            typeCurrentLesson: null,
            nameCourse: null,
            activeModule: 11,
            listLesson: [],
            dataCourse: null,
            hasLastLesson: false,
            modulesLoading: false,
            viewedLessonIds: {},
            modulesFetchSeq: 0,
            viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
        };
    },
    components: {
        SideBar,
        ViewCourse,
        Header,
    },
    computed: {
        ...mapState([
            'token',
            'user',
            'showSidebar',
            'dark',
            'currentLesson',
            'currentModuleOpen',
            'idLessonPortal',
            'nameCurrentLesson',
            'currentCoursePortal',
        ]),
        isMobileLayout() {
            return this.viewportWidth < 960;
        },
        courseDisplayName() {
            return (
                this.currentCoursePortal?.course?.comercialName
                || this.currentCoursePortal?.course?.name
                || this.nameCourse
                || ''
            );
        },
    },
    watch: {
        showSidebar: {
            immediate: true,
            handler(val) {
                if (!this.isMobileLayout) return;
                document.body.style.overflow = val ? 'hidden' : '';
            },
        },
    },
    methods: {
        ...mapActions([
            'storeTypeLessonPortal',
            'storeIdLessonPortal',
            'storeCurrentModuleOpen',
            'storeCurrentLesson',
            'storeNameCurrentLesson',
            'storePorcetageProgressCurrentCourse',
            'storeShowSidebar',
        ]),

        onResize() {
            const wasMobile = this.isMobileLayout;
            this.viewportWidth = window.innerWidth;
            if (!this.isMobileLayout) {
                document.body.style.overflow = '';
                if (!this.showSidebar) {
                    this.storeShowSidebar({ showSidebar: true });
                }
            } else if (!wasMobile && this.showSidebar) {
                this.storeShowSidebar({ showSidebar: false });
            }
        },

        closeSidebar() {
            this.storeShowSidebar({ showSidebar: false });
        },

        onKeydown(event) {
            if (event.key === 'Escape' && this.isMobileLayout && this.showSidebar) {
                this.closeSidebar();
            }
        },

        async getCourseProgressFromAPI() {
            try {
                if (
                    this.currentCoursePortal
                    && this.currentCoursePortal.course
                    && this.currentCoursePortal.course.id
                ) {
                    const courseResponse = await apiCourse.getDataCourse(
                        this.token,
                        this.currentCoursePortal.course.id,
                    );
                    if (courseResponse && courseResponse.progress != null) {
                        this.storePorcetageProgressCurrentCourse({
                            porcetageProgressCurrentCourse: courseResponse.progress,
                        });
                        return courseResponse.progress;
                    }
                }
            } catch (error) {
                console.error('Erro ao carregar progresso do curso:', error);
            }
            return null;
        },

        getLessonsArray(data) {
            const lessonsArray = [];
            data.forEach((item) => {
                if (item.lessons) {
                    lessonsArray.push(...item.lessons);
                }
            });
            this.listLesson = lessonsArray;

            if (this.listLesson && this.listLesson.length > 0) {
                this.storeIdLessonPortal({ idLessonPortal: this.listLesson[0].id });
                this.storeCurrentLesson({ currentLesson: this.listLesson[0] });
                this.storeTypeLessonPortal({ typeLessonPortal: this.listLesson[0].type });
                this.storeCurrentModuleOpen({ currentModuleOpen: 0 });
                this.storeNameCurrentLesson({ nameCurrentLesson: this.listLesson[0].title });
            } else {
                this.storeIdLessonPortal({ idLessonPortal: null });
                this.storeCurrentLesson({ currentLesson: null });
                this.storeTypeLessonPortal({ typeLessonPortal: null });
                this.storeNameCurrentLesson({ nameCurrentLesson: null });
            }
        },

        syncLessonsList(data) {
            const lessonsArray = [];
            (data || []).forEach((item) => {
                if (item.lessons) {
                    lessonsArray.push(...item.lessons);
                }
            });
            this.listLesson = lessonsArray;
        },

        resolveModuleToken() {
            return resolvePortalModuleToken({
                userType: this.user?.type,
                routeSlug: this.$route.params.slug,
                coursePortal: this.currentCoursePortal,
            });
        },

        async getDataLessonAndModules() {
            const id = this.resolveModuleToken();
            const seq = ++this.modulesFetchSeq;
            this.modulesLoading = true;
            if (!id) {
                toast.error(this.$t('student.player.modulesLoadError'));
                this.modulesLoading = false;
                return;
            }
            try {
                const response = await api.getDataModulesAndLesson(this.token, id);
                if (seq !== this.modulesFetchSeq) return;
                const modules = this.applyViewedLessons(response);
                this.dataModulesxLesson = modules;
                this.getLessonsArray(modules);
                this.syncProgressFromLessons(modules);
            } catch (error) {
                if (seq !== this.modulesFetchSeq) return;
                const denied = Number(error?.response?.status) === 403;
                toast.error(this.$t(denied ? 'student.player.noEnrollment' : 'student.player.modulesLoadError'));
                console.error('Erro ao gerar a lista de módulos e lições');
            } finally {
                if (seq === this.modulesFetchSeq) {
                    this.modulesLoading = false;
                }
            }
        },

        onProgressUpdated(lessonId) {
            const id = lessonId != null ? lessonId : this.idLessonPortal;
            if (id != null) {
                this.viewedLessonIds = {
                    ...this.viewedLessonIds,
                    [String(id)]: true,
                };
            }
            this.publishViewedProgress();
            this.refreshModulesAndProgress();
        },
        lessonMatchesViewed(lesson) {
            if (!lesson) return false;
            const keys = [lesson.id, lesson.idLesson, lesson.lessonId];
            return keys.some((key) => key != null && this.viewedLessonIds[String(key)]);
        },
        applyViewedLessons(modules) {
            const list = Array.isArray(modules) ? modules : [];
            return list.map((mod) => {
                const lessons = (mod.lessons || []).map((lesson) => (
                    this.lessonMatchesViewed(lesson)
                        ? { ...lesson, progress: 1 }
                        : lesson
                ));
                const done = lessons.filter((lesson) => Number(lesson.progress) === 1).length;
                const apiRead = Number(mod.lessonQtyRead);
                const lessonQtyRead = Number.isNaN(apiRead) ? done : Math.max(apiRead, done);
                return { ...mod, lessons, lessonQtyRead };
            });
        },
        publishViewedProgress() {
            if (!Array.isArray(this.dataModulesxLesson)) return;
            const modules = this.applyViewedLessons(this.dataModulesxLesson);
            this.dataModulesxLesson = modules;
            this.syncLessonsList(modules);
            this.syncProgressFromLessons(modules);
        },
        syncProgressFromLessons(modules) {
            const lessons = (modules || []).flatMap((mod) => mod.lessons || []);
            const total = lessons.length;
            const done = lessons.filter((lesson) => Number(lesson.progress) === 1).length;
            const percent = total ? Math.round((done / total) * 100) : 0;
            this.storePorcetageProgressCurrentCourse({
                porcetageProgressCurrentCourse: percent,
            });
        },
        /** Refetch módulos e % do curso sem resetar a aula atual. */
        async refreshModulesAndProgress() {
            const seq = ++this.modulesFetchSeq;
            const id = this.resolveModuleToken();
            if (!id) return;
            try {
                const response = await api.getDataModulesAndLesson(this.token, id);
                if (seq !== this.modulesFetchSeq) return;
                const modules = this.applyViewedLessons(response);
                this.dataModulesxLesson = modules;
                this.syncLessonsList(modules);
                this.syncProgressFromLessons(modules);
            } catch (error) {
                console.error('Erro ao atualizar módulos/progresso:', error);
            }
        },

        updateCurrentLesson(lessonId, typeLesson) {
            this.storeCurrentLesson({ currentLesson: lessonId });
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentTypeLesson(typeLesson) {
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentLessonName(nameLesson) {
            this.currentLessonName = nameLesson;
        },
        updateReviewMode(review) {
            this.currentLessonName = review;
        },
    },
    async created() {
        const idCourse = this.resolveModuleToken();
        await this.getDataLessonAndModules();

        if (idCourse && typeof this.getLastLesson === 'function') {
            await this.getLastLesson(idCourse);
        }
    },
    mounted() {
        this.viewportWidth = window.innerWidth;
        if (this.isMobileLayout) {
            this.storeShowSidebar({ showSidebar: false });
        }
        window.addEventListener('resize', this.onResize);
        window.addEventListener('keydown', this.onKeydown);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('keydown', this.onKeydown);
        document.body.style.overflow = '';
    },
};
</script>

<style scoped>
.global_content_course {
    --course-shell-bg: #F5F7FA;
    background-color: var(--course-shell-bg);
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    position: relative;
}

.global_content_course.dark {
    --course-shell-bg: #0f0e12;
    background-color: var(--course-shell-bg);
}

.course-layout {
    display: flex;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    width: 100%;
}

.course-layout__overlay {
    position: fixed;
    inset: 0;
    z-index: 40;
    background: rgba(15, 23, 42, 0.45);
}

.course-layout__sidebar {
    flex-shrink: 0;
    width: 340px;
    min-width: 320px;
    max-width: 360px;
    height: 100%;
    z-index: 50;
    background: #fff;
}

.global_content_course.dark .course-layout__sidebar {
    background: #1a191f;
}

.course-layout__sidebar.is-hidden {
    display: none;
}

.course-layout__main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    background: var(--course-shell-bg);
}

.course-layout__main--with-home-header :deep(.global_header.weeducStudentHeader) {
    flex-shrink: 0;
}

.course-layout__main--with-home-header > :deep(.global_view_content) {
    flex: 1;
    min-height: 0;
}

@media (max-width: 959px) {
    .global_content_course {
        height: 100dvh;
        min-height: 100dvh;
    }

    .course-layout__overlay {
        top: var(--course-mobile-header-h, 121px);
        z-index: 900;
    }

    .course-layout__sidebar {
        position: fixed;
        top: var(--course-mobile-header-h, 121px);
        left: 0;
        bottom: 0;
        width: 90%;
        max-width: 360px;
        min-width: 0;
        height: auto;
        z-index: 950;
        box-shadow: 4px 0 24px rgba(15, 23, 42, 0.12);
    }

    .course-layout__sidebar.is-hidden {
        display: none;
    }

    .course-layout__main--with-home-header :deep(.global_header.weeducStudentHeader) {
        z-index: 1000;
    }
}
</style>

<style>
.global_content_course.dark .box_question_quiz.review {
    background-color: #2a2a2a;
    color: white;
}
.global_content_course.dark .number_question_quiz {
    border-bottom: 1px solid #1a1a1a;
}
</style>
